export const STATUS_LOADING = 'loading'
export const STATUS_SUCCESS = 'success'
export const STATUS_ERROR = 'error'
export const USER_DETAILS_KEY = 'userDetails'
export const EDUCATION_PERIODS_KEY = 'educationPeriods'
export const SCORE_SEND_KEY = 'scoreSendData'
export const DEADLINES_KEY = 'deadlines'
export const STUDENT_ENROLLMENTS_KEY = 'studentEnrollments'
export const PROFILE_AND_REGISTRATION_KEY = 'profileAndRegistration'
